<template>
  <tr>
    <td>{{ __(title) }}</td>
    <td class="text-right">
      <v-skeleton-loader
        :loading="loading"
        type="text"
        max-width="40"
        class="ml-auto"
      >
        <span v-if="currency">{{ value | currency }}</span>
        <span v-else>{{ value }}</span>
      </v-skeleton-loader>
    </td>
  </tr>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      Currenciable,
      I18n,
    ],

    props: {
      title: {
        required: true,
        type: String,
      },
      value: {
        required: true,
      },
      currency: {
        required: false,
        type: Boolean,
        default: false,
      },
      loading: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
  }
</script>
